import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebaseConfig";

const ProtectedComponent = ({ children, isDocumentPage }) => {
  const [user, loading, error] = useAuthState(auth);

  if (loading) {
    return <p>Yükleniyor...</p>;
  }

  if (error) {
    return <p>Bir hata oluştu. Lütfen tekrar deneyin.</p>;
  }

  if (!user) {
    if (!isDocumentPage) {
      return <Navigate to="/not-found" />;
    }
  }

  return children;
};

export default ProtectedComponent;
